export default __webpack_public_path__ + "static/reviews-d8f9662ce187f5fbd4f8afca4a176f9a.webp";